import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import classnames from 'classnames';

var Accordion = (_param)=> {
    var { children , className  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children",
        "className"
    ]);
    return React.createElement("article", {
        className: classnames('accordion', className),
        "data-t": rest['data-t'] || 'accordion'
    }, children);
};

export { Accordion, Accordion as default };
//# sourceMappingURL=Accordion.js.map
